import { useEffect } from 'react';
import { useAuth } from '../firebase/useAuth';
import { useLocation } from 'react-router-dom';

const CrispChat = () => {
  const { email } = useAuth(); // Access the user's email from the auth hook
  const location = useLocation();

  useEffect(() => {
    // Initialize Crisp Chat
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = 'c0a254cc-2400-46c8-9abf-fd5eebc041d8'; // Your Crisp Website ID

    window.$crisp.push(['safe', true]);

    (function () {
      const d = document;
      const s = d.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = 1;
      d.getElementsByTagName('head')[0].appendChild(s);
    })();

    // Set the user's email once Crisp is loaded
    const interval = setInterval(() => {
      if (window.$crisp && window.$crisp.push) {
        if (email) {
          window.$crisp.push(['set', 'user:email', [email]]); // Set user email in Crisp
        }
        clearInterval(interval); // Stop checking once email is set
      }
    }, 200);

    return () => clearInterval(interval); // Cleanup the interval when the component unmounts
  }, [email]); // Re-run the effect if the email changes

  // Hide/show Crisp based on current route
  useEffect(() => {
    const isOnSessionPage = location.pathname.startsWith('/session/');

    if (window.$crisp) {
      if (isOnSessionPage) {
        window.$crisp.push(['do', 'chat:hide']);
      } else {
        window.$crisp.push(['do', 'chat:show']);
      }
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything visible
};

export default CrispChat;
